import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


class Reviewers {
  email_person: string = '';
  name: string = '';
}

@Component({
  selector: 'app-reviewer-modal',
  templateUrl: './reviewer-modal.component.html',
  styleUrls: ['./reviewer-modal.component.css']
})
export class ReviewerModalComponent implements OnInit{
  reviewers: Reviewers = new Reviewers();

  // use true to use on production
  demoData: boolean = false;

  @Input() my_modal_title:string = "Firma de documentos";
  @Input() my_modal_content:string = "Espectador";

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.demoData) {
      this.reviewers.email_person='juanmanuelriverom+viewer1@gmail.com';
      this.reviewers.name='Atencion Tracer';
      // this.reviewers.tax_id='AAA010101AAA'
    }
  }

  closeModalWithResult() {
    // Pass data back to the parent component
    this.activeModal.close(this.reviewers);
  }

  closeModalWithoutResult() {
    // Dismiss the modal without passing data
    this.activeModal.dismiss('Dismissed without result');
  }

  private isValidEmail(email: string): boolean {
    // Add your custom email validation logic here
    // You might want to use a regular expression or another validation method
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

}
